// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"HotelsSearchFooter_wrapper__79OyK","total":"HotelsSearchFooter_total__3XvW-"};